import { render } from "./BillGenerate.vue?vue&type=template&id=198f8094&scoped=true"
import script from "./BillGenerate.vue?vue&type=script&lang=js"
export * from "./BillGenerate.vue?vue&type=script&lang=js"

import "./BillGenerate.vue?vue&type=style&index=0&id=198f8094&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198f8094"]])

export default __exports__